import type { CSSProperties } from 'react'
import {
  DEFAULT_PRODUCT_IMAGE_FRAMING,
  normalizeStoredProductImageFraming,
  type ProductImageFraming,
} from '../../shared/productPresentation'
import '../styles/framed-product-image.css'

type FramedProductImageProps = {
  src: string
  alt: string
  framing?: ProductImageFraming | null
  className?: string
  imageClassName?: string
}

export default function FramedProductImage({
  src,
  alt,
  framing,
  className = '',
  imageClassName = '',
}: FramedProductImageProps) {
  const resolved = normalizeStoredProductImageFraming(
    framing,
    DEFAULT_PRODUCT_IMAGE_FRAMING,
  )
  const style = {
    '--product-image-focal-x': `${resolved.focalX * 100}%`,
    '--product-image-focal-y': `${resolved.focalY * 100}%`,
    '--product-image-zoom': resolved.zoom,
  } as CSSProperties

  return (
    <span
      className={`framed-product-image${className ? ` ${className}` : ''}`}
      style={style}
      data-product-image-framing="focal-point-v2"
    >
      <img
        className={`framed-product-image__image${imageClassName ? ` ${imageClassName}` : ''}`}
        src={src}
        alt={alt}
      />
    </span>
  )
}
